<template>
    <div class="card-wrap">
        <transition name="el-zoom-in-top">
            <div class="main">
                <p>
                    <el-image fit="cover" :preview-src-list="[headImg]" :src="headImg"></el-image>
                    <el-upload
                        :action="`${$http.baseUrl}/file/upload-image/v1`"
                        accept="image/jpeg, image/png"
                        :on-success="uploadSuccess"
                        :on-error="uploadError"
                        :before-upload="uploadBefore"
                        :with-credentials="true"
                        :show-file-list="false"
                    >
                        <el-button type="primary" icon="el-icon-camera-solid"></el-button>
                    </el-upload>
                </p>
                <p class="name">{{ getUserInfo.userName }}</p>
                <p>{{ getUserInfo.roleName }}</p>
                <p>{{ getUserInfo.mobile }}</p>
                <p>
                    <el-button type="primary" @click="dialogShow = true">修改密码</el-button>
                </p>
            </div>
        </transition>
        <el-dialog
            title="修改密码"
            :visible.sync="dialogShow"
            :before-close="handleClose"
            width="500px"
            :close-on-click-modal="false"
            append-to-body
        >
            <div class="content">
                <el-form
                    :inline="true"
                    :model="formEdit"
                    label-width="80px"
                    :rules="rules"
                    ref="formEdit"
                >
                    <div class="el-form-area">
                        <el-form-item label="原密码" prop="oldPassword">
                            <el-input v-model="formEdit.oldPassword" placeholder="请输入原密码" maxlength="10"></el-input>
                        </el-form-item>
                        <el-form-item label="新密码" prop="password">
                            <el-input v-model="formEdit.password" placeholder="请输入新密码" maxlength="10"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" prop="password2">
                            <el-input v-model="formEdit.password2" placeholder="请再次确认新密码" maxlength="10"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleSubmit">确定</el-button>
                <el-button @click="handleClose">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
let isLoading = null; // 是否正在上传头像
export default {
    computed: {
        ...mapGetters(['getUserInfo']),
        headImg() {
            return this.getUserInfo.photoPath
                ? '/staticfile/' + this.getUserInfo.photoPath
                : require('@/assets/images/nohead.png');
        }
    },
    data() {
        const validatePwd = (rule, val, callback) => {
            let reg = /^[a-zA-Z0-9]{6,10}$/;
            if (!reg.test(val)) {
                callback(new Error('请输入6-10位大、小写英文字母或数字'));
            } else {
                callback();
            }
        };
        const validatePwd2 = (rule, val, callback) => {
            if (val != this.formEdit.password) {
                callback(new Error('两次密码不一致'));
            } else {
                callback();
            }
        };
        return {
            dialogShow: false, // 修改密码弹窗
            formEdit: {
                oldPassword: '',
                password: ''
            },
            rules: {
                oldPassword: [
                    {
                        required: true,
                        validator: validatePwd,
                        trigger: 'blur'
                    }
                ],
                password: [
                    {
                        required: true,
                        validator: validatePwd,
                        trigger: 'blur'
                    }
                ],
                password2: [
                    {
                        required: true,
                        validator: validatePwd2,
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    methods: {
        // 密码弹窗关闭
        handleClose() {
            this.$refs.formEdit.resetFields();
            this.dialogShow = false;
        },
        // 上传前
        uploadBefore(file) {
            // 判断文件类型
            let arr = file.name.split('.');
            let suffix = arr[arr.length - 1];
            let type = ['jqeg', 'jpg', 'png'];
            if (type.filter(item => item == suffix.toLowerCase()).length == 0) {
                this.$message.error('图片格式不正确');
                return false;
            }
            // 判断文件大小
            if (file.size > this.size * 1024 * 1024) {
                this.$message.error(`只能上传2M以下的图片`);
                return false;
            }
            this.isLoading = this.$loading(this.$http.loadingOption);
        },
        // 上传头像成功
        uploadSuccess(response) {
            this.$http
                .put('/account/updateimage/v1', {
                    photoPath: response.message.resource
                })
                .then(() => {
                    this.isLoading.close();
                    this.$message.success('上传成功');
                    this.$store.dispatch('updateUserInfo');
                });
        },
        // 上传头像失败
        uploadError() {
            this.isLoading.close();
            this.$message.error('上传失败');
        },
        // 密码提交
        handleSubmit() {
            this.$refs.formEdit.validate(valid => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        this.$http
                            .put(
                                '/account/updatepassword/v1',
                                this.formEdit,
                                '提交中……',
                                '修改成功，请重新登录'
                            )
                            .then(() => {
                                this.handleClose();
                            });
                    });
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.card-wrap {
    .main {
        position: relative;
        padding: 30px 0px;
        border-radius: 4px;
        p {
            color: #b5c3d1;
            font-size: 16px;
            text-align: center;
            line-height: 2;
            &:first-child {
                position: relative;
                height: 124px;
                .el-image {
                    height: 124px;
                    width: 124px;
                    border-radius: 50%;
                }
                .el-button {
                    position: absolute;
                    height: 42px;
                    width: 42px;
                    border-radius: 50%;
                    bottom: 0;
                    right: 49px;
                    line-height: 42px;
                    font-size: 24px;
                    color: #fff;
                    padding: 0;
                }
            }
            &:last-child {
                margin-top: 20px;
            }
        }
        .name {
            color: #333c54;
            font-size: 28px;
            font-weight: 600;
        }
    }
}
</style>